<template>
    <div class="global-banners-container">
        <GlobalTopBanner
            v-if="paymentFailure"
            id="payment_failed"
            type="error"
            :message="
                $t('banners.payment_failed.message', {
                    amount: '79,00',
                    symbol: $symbolCurrency,
                    date: '12 mars 2026',
                    card: '****4242',
                })
            "
            :action-label="$t('banners.payment_failed.action')"
            action-url="/back-office/manage-subscription"
            :persist-close="false"
        />
        <GlobalTopBanner
            v-if="subscriptionCanceled"
            id="subscription_canceled"
            type="warning"
            :message="$t('banners.subscription_canceled.message', { date: subscriptionEndsAt })"
            :action-label="$t('banners.subscription_canceled.action')"
            action-url="/back-office/manage-subscription"
            :persist-close="true"
        />
        <GlobalTopBanner
            v-if="!paymentFailure && !subscriptionCanceled && trialEndsIn > 0"
            id="trial_ending"
            type="info"
            :message="$t('banners.trial_ending.message', { days: trialEndsIn })"
            :action-label="$t('banners.trial_ending.action')"
            action-url="/back-office/subscription"
            :persist-close="false"
        />
    </div>
</template>

<script>
import GlobalTopBanner from './GlobalTopBanner.vue'

export default {
    name: 'BannersContainer',
    components: {
        GlobalTopBanner,
    },
    props: {
        paymentFailure: {
            type: Boolean,
            default: false,
        },
        trialEndsIn: {
            type: Number,
            default: 0,
        },
        subscriptionCanceled: {
            type: Boolean,
            default: false,
        },
        subscriptionEndsAt: {
            type: String,
            default: '',
        },
    },
}
</script>

<style scoped>
.global-banners-container {
    width: 100%;
    position: relative;
    z-index: 9999;
}
</style>
